var _path, _line, _line2, _line3, _line4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.90825 1.68345C10.5441 1.30539 11.4567 1.30539 12.0925 1.68345L19.9605 6.36151C21.2209 7.11096 20.4945 8.5999 18.8683 8.5999H3.13244C1.5063 8.5999 0.779832 7.11096 2.04031 6.36152L9.90825 1.68345Z",
    stroke: "#282829",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.55078,
    y1: 11.1499,
    x2: 5.55078,
    y2: 15.6499,
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 9.63086,
    y1: 11.1499,
    x2: 9.63086,
    y2: 15.6499,
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 13.7109,
    y1: 11.1499,
    x2: 13.7109,
    y2: 15.6499,
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 17.791,
    y1: 11.1499,
    x2: 17.791,
    y2: 15.6499,
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.40039,
    y: 18.2002,
    width: 19.2,
    height: 2.4,
    rx: 0.9,
    stroke: "#282829",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e450e6d8753eaf42f63ac99138a70476.svg";
export { ForwardRef as ReactComponent };